import { Component, inject, Inject, Optional } from '@angular/core';
import { AbstractControl, FormControl,  FormGroup,  ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Constants } from '../../../common/constrants';
import { UserService } from '../../services/user/user.service';
import { BaseComponent } from '@nucleus/ui-base';
import { MatIconModule } from '@angular/material/icon';
import { ChangePasswordPayload, User } from '@nucleus/user-ui';
import { NgIf } from '@angular/common';
import { FormErrorSummaryComponent } from "@nucleus/form-error-summary-ui";
import { PageHeaderComponent } from "@nucleus/ui-base";

export interface ChangePasswordDataDialogData {
}

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.css',
    imports: [MatFormFieldModule,
        NgIf,
        MatInputModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatDialogModule,
        MatDialogClose,
        MatToolbarModule,
        MatIconModule,
        FormErrorSummaryComponent,
        PageHeaderComponent]
})
export class ChangePasswordComponent extends BaseComponent {

  public VALUES = Constants;
  userService: UserService = inject(UserService);

  dialogForm : FormGroup;

  /** Field labels for the global form-error-summary inside the dialog. */
  readonly errorFieldLabels: Record<string, string> = {
    passwordFormControl:        'New Password',
    confirmPasswordFormControl: 'Confirm Password',
  };

  passwordFormControl : FormControl = new FormControl("", [
        Validators.required,
        Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/),
        Validators.minLength(Constants.USER_PASSWORD_MIN_LENGTH), Validators.maxLength(Constants.USER_PASSWORD_MAX_LENGTH)]);
  
  confirmPasswordFormControl : FormControl = new FormControl("", [
        Validators.required]);
  
  //       password: string = "";
  // confirmPassword: string = "";
  passwordVisible : boolean = false;
  confirmPasswordVisible : boolean = false;

  constructor(
    // This component is used BOTH as a dialog (opened from the header menu via
    // MatDialog.open) AND as a routed page (/settings/change-password). The
    // dialog-only deps must be optional so the routed context — which has no
    // MatDialog provider chain — doesn't throw a NullInjectorError on load.
    @Optional() public dialogRef: MatDialogRef<ChangePasswordDataDialogData> | null,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ChangePasswordDataDialogData | null) {
      super();
      this.dialogForm = new FormGroup(
        {
          passwordFormControl : this.passwordFormControl,
          confirmPasswordFormControl : this.confirmPasswordFormControl
        }, { validators: this.passwordMatchValidator});
  }


  passwordMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const password = group.get('passwordFormControl')?.value;
    const confirmPassword = group.get('confirmPasswordFormControl')?.value;
    if (password != confirmPassword) {
      return { passwordMismatch: true };
    }
    return null;
  }

  changePassword() : void {
    this.confirm(
      'Confirmation',
      `Are you sure you want to change your password?`
    ).then((confirmation) => {
      if (confirmation) {
        let payload: ChangePasswordPayload = {
          password: this.passwordFormControl.value,
          confirmPassword: this.confirmPasswordFormControl.value,
        };
        this.userService.changePassword(payload, {
          onStart: () => {},
          onSuccess: (user: User) =>
            super.showSuccess(`Your password has been successfully changed.`),
          onError: (error: string) => super.showError(error),
          onComplete: () => {},
        });
      }
    });
  }

  canSave() : boolean {
    return this.dialogForm.valid;
  }

  togglePasswordVisibility() : void {
    this.passwordVisible  = ! this.passwordVisible;
  }

  toggleConfirmPasswordVisibility() : void {
    this.confirmPasswordVisible  = ! this.confirmPasswordVisible;
  }
}
